import { render } from "./McpServers.vue?vue&type=template&id=c251613c&scoped=true"
import script from "./McpServers.vue?vue&type=script&lang=js"
export * from "./McpServers.vue?vue&type=script&lang=js"

import "./McpServers.vue?vue&type=style&index=0&id=c251613c&scoped=true&lang=css"
import "./McpServers.vue?vue&type=style&index=1&id=c251613c&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c251613c"]])

export default __exports__